<template>
  <transition-group class="toast-container" name="toast" tag="div">
    <div class="toast-message" v-for="message in queue" :key="message.id">{{message.message}}</div>
  </transition-group>
</template>

<script>
import { injectToastMessageQueue } from './toast'

export default {
  name: 'Toast',
  setup () {
    const queue = injectToastMessageQueue().queue
    return {
      queue
    }
  }
}
</script>

<style scoped lang="scss">
.toast-container{
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 1;
  min-width: 250px;
  max-width: 500px;
  transform: translateX(-50%);
}
.toast-message {
  background-color: $tooltip-background-color;
  border-radius: $tooltip-border-radius;
  color: #fff;
  font-size: $tooltip-font-size;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  padding: $tooltip-padding;
  margin-bottom: 12px;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.5s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  visibility: hidden;
  transform: translateY(30px);
}

.toast-move {
  transition: transform 0.5s ease;
}
</style>
